import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/page/login/login';
import NotFound from '@/page/errorPage/404';
import Forbidden from '@/page/errorPage/403';
import Layout from '@/page/layout/index';
import store from '@/store/index';
import {
    Message
} from "element-ui";

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push (location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err);
};

/* 初始路由 */
var router = new Router({
    routes: [
        {
            path: '/login',
            component: Login
        }
    ]
});
export default router;
/* 准备动态添加的路由 */
let Home = () => import('@/page/layout/component/MobileHome');
export const DynamicRoutes = [
    {
        path: '/',
        component: Layout,
        name: 'container',
        //redirect: 'home',
        meta: {
            requiresAuth: true,
            name: '首页'
        },
        children: []
    },
    // {
    //     path: '/mobileHome',
    //     component: Home,
    //     name: 'mobileHome',
    //     meta: {
    //         requiresAuth: true,
    //         name: '首页'
    //     },
    //     // children: [{
    //     //     path: 'home',
    //     //     component: Home,
    //     //     name: 'home',
    //     //     meta: {
    //     //         name: '首页',
    //     //         //icon: 'icon-home'
    //     //     }
    //     // },]
    // },
    {
        path: '/403',
        component: Forbidden
    },
    {
        path: '*',
        component: NotFound
    }
];

/* 教学管理 */
const teaching = () => import('@/page/teaching-manage/index');
const teachingManage = () => import('@/page/teaching-manage/menuPage/teachingManage');
const courseList = () => import('@/page/teaching-manage/menuPage/courseList');
const courseListDetail = () => import('@/page/teaching-manage/menuPage/courseListDetail');
const classDetails = () => import('@/page/teaching-manage/menuPage/classDetails');
//随堂测评-h5
const classAssessment = () => import('@/page/teaching-manage/menuPage/classAssessment');
/* 学员管理 */
const student = () => import('@/page/student-manage/index');
const studentManage = () => import('@/page/student-manage/menuPage/studentManage');
//学员详情
const studentDetail = () => import('@/page/student-manage/menuPage/studentDetail');

/* 班级管理 */
const classrooms = () => import('@/page/class-manage/index');
const classManage = () => import('@/page/class-manage/menuPage/classManage');
//班级详情
const classDetail = () => import('@/page/class-manage/menuPage/classDetail');


/* 订单管理 */
const order = () => import('@/page/order-manage/index');
const orderManage = () => import('@/page/order-manage/menuPage/orderManage');
const courseOrderDetail = () => import('@/page/order-manage/menuPage/courseOrderDetail');
const accountOrderDetail = () => import('@/page/order-manage/menuPage/accountOrderDetail');

/*作品管理*/
const works = () => import('@/page/work-manage/index');
const workManage = () => import('@/page/work-manage/menuPage/workManage');
const workDetail = () => import('@/page/work-manage/menuPage/workDetail');

/* 学情管理 */
const learningReport = () => import('@/page/learningReport-manage/index');
const learningReportManage = () => import('@/page/learningReport-manage/menuPage/learningReportManage');
const studentlearningReport = () => import('@/page/learningReport-manage/menuPage/studentlearningReport');

/* 创作工具 */
const authoringTools = () => import('@/page/tools-manage/index');
const toolsManage = () => import('@/page/tools-manage/menuPage/toolsManage');

export const dynamicRoutes_role = [
    {
        path: '/teaching',
        component: teaching,
        name: 'teaching',
        meta: {
            name: '教学管理',
            isShow: true,
            isShowChildren: false,
            icon: '../../static/images/main/icon1.png',
            icon_c: '../../static/images/main/icon1_c.png'
        },
        children: [
            {
                path: 'teachingManage',
                component: teachingManage,
                name: 'teachingManage',
                meta: {
                    name: '教学管理',
                    isShow: false,
                    activeMenu: "teaching",
                },
            },
            {
                path: 'courseList',
                name: 'courseList',
                component: courseList,
                meta: {
                    name: '课程列表',
                    isShow: false,
                    activeMenu: "teaching",
                }
            },
            {
                path: 'courseListDetail',
                name: 'courseListDetail',
                component: courseListDetail,
                meta: {
                    name: '课程列表详情',
                    isShow: false,
                    activeMenu: "teaching",
                }
            },
            {
                path: 'classDetails',
                name: 'classDetails',
                component: classDetails,
                meta: {
                    name: '课时详情',
                    isShow: false,
                    activeMenu: "teaching",
                }
            },
            {
                path: 'classAssessment',
                name: 'classAssessment',
                component: classAssessment,
                meta: {
                    name: '随堂测评',
                    isShow: false,
                    activeMenu: "teaching",
                }
            }
        ]
    },
    {
        path: '/student',
        component: student,
        name: 'student',
        meta: {
            name: '学员管理',
            isShow: true,
            isShowChildren: false,
            icon: '../../static/images/main/icon2.png',
            icon_c: '../../static/images/main/icon2_c.png'
        },
        children: [
            {
                path: 'studentManage',
                name: 'studentManage',
                component: studentManage,
                meta: {
                    name: '学员管理',
                    isShow: true,
                    activeMenu: "student",
                }
            },
            {
                path: 'studentDetail',
                name: 'studentDetail',
                component: studentDetail,
                meta: {
                    name: '学员详情',
                    isShow: false,
                    activeMenu: "student",
                }
            }
        ]
    },
    {
        path: '/classrooms',
        component: classrooms,
        name: 'classrooms',
        meta: {
            name: '班级管理',
            isShow: true,
            isShowChildren: false,
            icon: '../../static/images/main/icon3.png',
            icon_c: '../../static/images/main/icon3_c.png'
        },
        children: [
            {
                path: 'classManage',
                name: 'classManage',
                component: classManage,
                meta: {
                    name: '班级管理',
                    isShow: true,
                    activeMenu: "classrooms"
                }
            },
        ]
    },
    // {
    //     path: '/order',
    //     component: order,
    //     name: 'order',
    //     meta: {
    //         name: '订单管理',
    //         isShow: true,
    //         isShowChildren: false,
    //         icon: '../../static/images/main/icon4.png',
    //         icon_c: '../../static/images/main/icon4_c.png'
    //     },
    //     children: [
    //         {
    //             path: 'orderManage',
    //             name: 'orderManage',
    //             component: orderManage,
    //             meta: {
    //                 name: '订单管理',
    //                 isShow: true,
    //                 activeMenu: "order",
    //             }
    //         },
    //         {
    //             path: 'courseOrderDetail',
    //             name: 'courseOrderDetail',
    //             component: courseOrderDetail,
    //             meta: {
    //                 name: '课程订单详情',
    //                 isShow: false,
    //                 activeMenu: "order",
    //             }
    //         },
    //         {
    //             path: 'accountOrderDetail',
    //             name: 'accountOrderDetail',
    //             component: accountOrderDetail,
    //             meta: {
    //                 name: '账号订单详情',
    //                 isShow: false,
    //                 activeMenu: "order",
    //             }
    //         }
    //     ]
    // },
    {
        path: '/works',
        component: works,
        name: 'works',
        meta: {
            name: '作品管理',
            isShow: true,
            isShowChildren: false,
            icon: '../../static/images/main/icon5.png',
            icon_c: '../../static/images/main/icon5_c.png'
        },
        children: [
            {
                path: 'workManage',
                name: 'workManage',
                component: workManage,
                meta: {
                    name: '作品管理',
                    isShow: true,
                    activeMenu: "works",
                    //icon: 'icon-quit'
                }
            },
            {
                path: 'workDetail',
                name: 'workDetail',
                component: workDetail,
                meta: {
                    name: '作品详情',
                    isShow: true,
                    activeMenu: "works",
                    //icon: 'icon-quit'
                }
            },
        ]
    },
    {
        path: '/learningReport',
        component: learningReport,
        name: 'learningReport',
        meta: {
            name: '学情管理',
            isShow: true,
            isShowChildren: false,
            icon: '../../static/images/main/icon6.png',
            icon_c: '../../static/images/main/icon6_c.png'
        },
        children: [
            {
                path: 'learningReportManage',
                name: 'learningReportManage',
                component: learningReportManage,
                meta: {
                    name: '学情管理',
                    isShow: true,
                    activeMenu: "learningReport",
                    //icon: 'icon-quit'
                }
            },
            {
                path: 'studentlearningReport',
                name: 'studentlearningReport',
                component: studentlearningReport,
                meta: {
                    name: '学员详情',
                    isShow: false,
                    activeMenu: "learningReport",
                }
            }
        ]
    },
    {
        path: '/authoringTools',
        component: authoringTools,
        name: 'authoringTools',
        meta: {
            name: '创作工具',
            isShow: true,
            isShowChildren: false,
            icon: '../../static/images/main/icon7.png',
            icon_c: '../../static/images/main/icon7_c.png'
        },
        children: [
            {
                path: 'toolsManage',
                name: 'toolsManage',
                component: toolsManage,
                meta: {
                    name: '创作工具',
                    isShow: true,
                    activeMenu: "authoringTools",
                    //icon: 'icon-quit'
                }
            },
        ]
    },
];

router.beforeEach((to, from, next) => {
    if (!store.state.UserToken) {
        if (
            to.matched.length > 0 &&
            !to.matched.some(record => record.meta.requiresAuth)
        ) {
            next();

        } else {
            next({ path: '/login' });
        }
    } else {
        if (!store.state.permission.permissionList) {
            store.dispatch('permission/FETCH_PERMISSION').then(() => {
                next({ path: to.path });
            });
        } else {
            if (to.path !== '/login') {
                next();
            } else {
                next(from.fullPath);
            }
        }
    }
});

router.afterEach((to, from, next) => {
    var routerList = to.matched;
    store.commit('setCrumbList', routerList);
    store.commit('permission/SET_CURRENT_MENU', to.meta.activeMenu);
});



// WEBPACK FOOTER //
// ./src/router/index.js